/**
 * Shared constants for Correly.
 */

export const PROTOCOL_CATEGORIES = [
  { key: 'diet', label: 'Diet', icon: '🥗' },
  { key: 'rest', label: 'Rest', icon: '😴' },
  { key: 'exercise', label: 'Exercise', icon: '🏃' },
  { key: 'stress', label: 'Stress Reduction', icon: '🧘' },
  { key: 'supplementation', label: 'Supplementation', icon: '💊' },
];

export const FREQUENCY_OPTIONS = [
  { value: 'daily', label: 'Daily' },
  { value: 'twice_daily', label: 'Twice Daily' },
  { value: 'three_times_daily', label: 'Three Times Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'as_needed', label: 'As Needed' },
];

export const PHOTO_CATEGORIES = [
  { value: 'food', label: 'Food' },
  { value: 'symptoms', label: 'Symptoms' },
  { value: 'progress', label: 'Progress' },
];

export const PLAN_TIERS = {
  starter: {
    name: 'Starter',
    price: 29,
    maxClients: 5,
    maxTeamMembers: 0,
    features: ['Full protocol builder', 'Protocol templates', 'Client daily logging', 'Push notifications', 'In-app messaging', 'Compliance tracking & charts'],
  },
  solo: {
    name: 'Solo',
    price: 49,
    maxClients: 15,
    maxTeamMembers: 0,
    features: ['Everything in Starter', 'Up to 15 active clients'],
  },
  practice: {
    name: 'Practice',
    price: 99,
    maxClients: Infinity,
    maxTeamMembers: 3,
    features: ['Everything in Solo', 'Unlimited active clients', 'Up to 3 team members', 'Priority support'],
  },
};

export const CHART_TIMEFRAMES = [
  { value: 7, label: '7 days' },
  { value: 30, label: '30 days' },
  { value: 90, label: '90 days' },
  { value: 0, label: 'All time' },
];
